import {createReducer} from 'helpers';

export const lastChangeTimestamp = createReducer(0, {
  GOOGLE_CALENDAR_SUCCESSFUL_CHANGE: (state, action) => action.timestamp_ms,
});
